module.exports = __webpack_public_path__ + "static/media/knee-quizz.f811cb7d.jpg";